"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransitionGroupChild = exports.TransitionGroup = void 0;
const react_1 = __importStar(require("react"));
const RTG = __importStar(require("react-transition-group"));
const react_2 = require("@headlessui/react");
function TransitionGroup(props) {
    return react_1.default.createElement(RTG.TransitionGroup, Object.assign({}, props));
}
exports.TransitionGroup = TransitionGroup;
function TransitionGroupChild(_a) {
    var { in: _in, children, appear, enter, 
    // extra props that RTG.TransitionGroup injects
    exit, onExited } = _a, props = __rest(_a, ["in", "children", "appear", "enter", "exit", "onExited"]);
    const doneRef = (0, react_1.useRef)(() => { });
    return (react_1.default.createElement(RTG.Transition, { in: _in, appear: appear, addEndListener: (_, done) => {
            doneRef.current = done;
        }, onExited: onExited }, (state) => (react_1.default.createElement(react_2.Transition, Object.assign({ show: state === 'entering' || state === 'entered', appear: appear, 
        // check necessary - RTG injects a boolean enter prop if defined
        enter: typeof enter === 'string' ? enter : undefined }, props, { afterEnter: () => {
            var _a;
            doneRef.current();
            (_a = props.afterEnter) === null || _a === void 0 ? void 0 : _a.call(props);
        }, afterLeave: () => {
            var _a;
            doneRef.current();
            (_a = props.afterLeave) === null || _a === void 0 ? void 0 : _a.call(props);
        } }), children))));
}
exports.TransitionGroupChild = TransitionGroupChild;
TransitionGroup.Child = TransitionGroupChild;
